import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CanActivateRoute } from '../../../guards';
import { ReservationOptionsComponent } from './reservation-options.component';

const routes: Routes = [{
  path: '',
  component: ReservationOptionsComponent,
  canActivate: [CanActivateRoute],
  data: {
    scopes: ['manager:write']
  },
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReservationOptionsRoutingModule {}
